import React from "react";
import Modal from "antd/lib/modal";
import bindAll from 'lodash.bindall';
import './operation-button.css';
import {connect} from 'react-redux';
import { onXESConfirmSubmit,onXESCheckBackGround } from "../../../reducers/project-state.js";
import Button from 'antd/lib/button'
import { getEnv, Environment } from "../../../lib/xes/xes";

let toggleSubmitLoading
class SubmitButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      loading: false
    }
    toggleSubmitLoading = (loading) => {
      this.setState({
        loading
      })
    }
    bindAll(this, [
      'handleSubmit',
      'handleConfirmSubmit',
      'handleCancel',
      'openModal',
      'closeModal'
    ])
    this.env = getEnv();
    this.isSupportEnv = [Environment.CLASSWORK, Environment.BAIZE].includes(this.env)
      ? true
      : false;
  }
  componentDidUpdate(preProps) {
  }
  openModal() {
    this.setState({
      modalVisible: true
    })
  }
  closeModal() {
    this.setState({
      modalVisible: false
    })
  }
  handleSubmit() {
    // this.openModal()
    if (this.isSupportEnv) {
      this.props.dispatch(onXESCheckBackGround("submit"));
    } else {
      this.openModal();
    }
  }
  handleConfirmSubmit() {
    // this.closeModal()
    // this.props.dispatch(onXESConfirmSubmit())
    if (this.isSupportEnv) {
      this.props.dispatch(onXESCheckBackGround("submit"));
    } else {
      this.closeModal();
      this.props.dispatch(onXESConfirmSubmit());
    }
  }
  handleCancel() {
    this.closeModal()
  }
  render() {
    return (
      <div className={this.props.className}>
        <Button
          style={{
            color: '#4A82F7',
            borderRadius: '0.25rem',
            outline: 'none',
            border: 'none',
            fontSize: '0.88rem',
            fontWeight: '600'
          }}
          className="xes-button"
          onClick={this.handleSubmit}
          loading={this.state.loading}
        >
          提交
        </Button>
        <Modal
          title="提交"
          cancelText="取消"
          okText="确定"
          visible={this.state.modalVisible}
          onOk={this.handleConfirmSubmit}
          onCancel={this.handleCancel}
        >
          <p>提交后无法修改</p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state
})
const mapDispatchToProps = (dispatch) => ({
  dispatch
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubmitButton)

export {
  toggleSubmitLoading
}
